
import React, {Component} from 'react';
import { IntercomAPI } from 'react-intercom';


import HeaderComponent from "../../header/components/HeaderComponent";
import MenuComponent from "../../../menu/components/MenuComponent";
import axios from "axios";
import {Link} from "react-router-dom";
import LoadingComponent from "../../loading/components/LoadingComponent";
import "../style/CreateMyOwnListStyle.scss"
import ProductComponent from "../../products/components/ProductComponent";
import FeedBackMsgComponents from "../../feedbackmsg/components/FeedBackMsgComponents";

class CreateMyOwnListComponent extends Component {

    constructor(props) {
        super(props);
        this.filter = {};
        this.state = {
            products: [],
            loading: true,
            productList: []
        }
        this.timer = null;
        this.closeFeedback = this.closeFeedback.bind(this)
    }

    headers = {
        headers: {Authorization: `Bearer ${window.localStorage.getItem('access_token')}`},
    };

    api2 = "";

    list = [];

    url = `${process.env.REACT_APP_API_URL}/api/product/?collections=${this.props.match.params.id}&create_my_own_list=true&limit=500&return_type=variations  `;

    api = `/download-custom-linesheet/?`;

    getCreateMyOwnList() {
        axios.get(this.url, this.headers)
            .then((response) => {
                this.setState({
                    products: response.data,
                    loading: false
                });
                let segments = response.data.meta.segments
                if (segments.length === 1) {
                  var metadata = {
                    segmentName: segments[0].name,
                  }
                  IntercomAPI('trackEvent', 'access-showcase-page', metadata)
                }
            });
    }

    componentDidMount() {
        this.getCreateMyOwnList();
    }

    setFilters(api) {
        this.api2 = api;
    }

    makeCreateMyOwnList(value, product) {
        this.setState({
            productList: product
        });

        let api = "";
        value.forEach( (id) => {
            api += "variations="+id+"&";
        });

        this.setFilters(api);
    }

    async addCart() {
        let list = this.state.productList;
        if(list.length > 0) {
            axios.post("api/cart/add/", {ids: list}).then((response)=>{
              this.setState({
                msg: true,
              });
              this.showFeedback();

            }).catch(ex => {
                if(ex.response.status === 409) {
                    this.setState( {
                        isProductInCart: true
                    })
                    this.showFeedback();
                }
            });
        }
    }

    goLineSheet() {
      if(this.api2){
        window.open(
          `${process.env.REACT_APP_API_URL}/api${this.api}${this.api2}`,
          '_blank'
        );
      }
    }
    showFeedback(){
      this.setState({
        showFeedback: true
      })
      clearTimeout(this.timer);
      this.timer = setTimeout(this.closeFeedback, 4000);
    }
    closeFeedback(){
      clearTimeout(this.timer);
      this.setState({
        showFeedback: false,
        msg: false,
        isProductInCart: false
      })
    }

    render() {

        if(this.state.loading) {
            return <LoadingComponent/>
        }

        return (
            <div>
                <HeaderComponent />
                <MenuComponent />
                  { this.state.showFeedback && this.state.msg &&
                    <FeedBackMsgComponents close={this.closeFeedback}>
                      GREAT! THE ITEMS HAS BEEN ADDED TO YOUR CART. CLICK <span className="here">
                      <Link to={{pathname: '/cart', state: {sellerId: this.state.products.meta.sellers[0].id}}}>HERE</Link></span> TO CHECK IT OUT.
                    </FeedBackMsgComponents>
                  }

                  {this.state.showFeedback && this.state.isProductInCart &&
                      <FeedBackMsgComponents msg="THIS PRODUCT IS ALREADY IN YOUR CART." close={this.closeFeedback}/>
                  }
                <section className="centerComponent" id="lineSheetColletion">
                    <h1>Customized line sheet from </h1>
                    <h2 className="brand-name">{this.state.products.meta.sellers[0].name}</h2>

                    <div className="textLineSheet">
                        <p>
                            Customize your own line sheet selecting the products you liked. Then, you can download as
                            PDF file, by clicking on the button <span className="downloadText">&nbsp;</span>, or add these products straight to your cart,
                            by clicking on the button <span className="cartText">&nbsp;</span>.
                        </p>
                    </div>

                    <div className="containerProduct">
                        <ProductComponent makeCreateMyOwnList={this.makeCreateMyOwnList.bind(this)} isCheckBox={true} products={this.state.products.results} />
                    </div>

                    <div className="cartAndDownload">
                        <ul>
                            {window.localStorage.getItem("user_type") === "buyer" &&
                                <li className="cart" onClick={() => this.addCart()}>
                                    <span />
                                    <p>Add to cart</p>
                                </li>
                            }
                            <li className="download" onClick={() => this.goLineSheet()}>
                                <span></span>
                                <p>Download as PDF</p>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        );
    }
}

export default CreateMyOwnListComponent;
